import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Hotkey } from 'ui-components/components/hotkey';

const messages = defineMessages({
  name: {
    description: 'modalHotkey.productCodeEnter',
    defaultMessage: 'Product Code Enter',
    id: 'QDPRZT',
  },
});

const stringMatchingValidation = (str) =>
  str !== 'escape' && str !== 'v' && !str.startsWith('+') && !str.startsWith('^#^') && !str.endsWith('=');

const ProductCodeEnterHotkey = ({ children, onProductCodeEnter }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: [],
      doNotClearBufferOnCompleteMatch: true,
      doNotTrack: true,
      handler: onProductCodeEnter,
      legacyCategory: 'general',
      matches: (str, inputBuffer) => {
        return (
          stringMatchingValidation(str) &&
          inputBuffer.reduce((isMatch, key) => {
            return !key.hasCtrlEquivalent && !key.hasAlt && isMatch;
          }, true)
        );
      },
      name: intl.formatMessage(messages.name),
      partialMatch: ['**'],
    }),
    [intl, onProductCodeEnter],
  );

  return <Hotkey hotkey={hotkeyMetadata}>{children}</Hotkey>;
};

ProductCodeEnterHotkey.propTypes = {
  children: PropTypes.node.isRequired,
  onProductCodeEnter: PropTypes.func.isRequired,
};

export default ProductCodeEnterHotkey;
